export function calculateCurrencyPriceWithDiscount(
  exchangeRate: number,
  basePrice: number,
  discount: number
): number {
  return Math.floor(exchangeRate * basePrice * (1 - discount / 100));
}
